import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import { BankDetails, CreditCardDetails, PAYMENT_TYPE } from "../../../state/helpers/Payment"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import "./PaymentTypeLabel.scss"

type OwnProps = {
    creditCardDetails?: CreditCardDetails,
    bankAccountDetails?: BankDetails,
    paymentType: PAYMENT_TYPE,
    integrationKey: INTEGRATION_KEY,
}

const PaymentTypeLabel = (props: OwnProps & IntlProps) => {
    const getExternalProcessorLogo = (): string => {
        switch (props.integrationKey) {
        case INTEGRATION_KEY.STRIPE:
            return "/images/stripe_logo.png"
        case INTEGRATION_KEY.SQUARE:
        case INTEGRATION_KEY.SQUARE_PAYMENTS:
            return "/images/square_logo.png"
        default:
            return ""
        }
    }
    
    const getCreditCardPaymentLabel = () => {
        if (props.creditCardDetails) {
            if (props.integrationKey === INTEGRATION_KEY.RAINFOREST) {
                return (
                    <span className="payment-method-label">
                        {props.creditCardDetails.attributes.brand}
                        <FormattedMessage
                            id="invoice.payment_refund_table.card_ending_in"
                            defaultMessage="ending in"
                        />
                        {props.creditCardDetails.attributes.last4}
                    </span>
                )
            } else {
                const logo = getExternalProcessorLogo()
                return logo
                    ? (
                        <span className="payment-method-label">
                            <FormattedMessage
                                id="invoice.payment_refund_table.payment_type.external_processor"
                                defaultMessage="Captured by"
                            />
                            <img src={logo} width="50px" alt="Processor Logo" />
                        </span>
                    )
                    : (
                        <span className="payment-method-label">
                            <FormattedMessage
                                id="invoice.payment_refund_table.payment_type.external"
                                defaultMessage="Captured by external processor"
                            />
                        </span>
                    )
            }
        }
    }

    const getBankAccountPaymentLabel = () => {
        if (props.bankAccountDetails) {
            return (
                <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.bank_ending_in"
                        defaultMessage="Bank account ending in"
                    />
                    {props.bankAccountDetails.attributes.last4}
                </span>
            )
        }
    }

    const getOtherPaymentLabel = () => {
        if (!props.creditCardDetails && !props.bankAccountDetails) {
            switch (props.paymentType) {
            case PAYMENT_TYPE.CHECK:
                return <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.payment_type.check"
                        defaultMessage="Check"
                    />
                </span>
            case PAYMENT_TYPE.CASH:
                return <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.payment_type.cash"
                        defaultMessage="Cash"
                    />
                </span>
            case PAYMENT_TYPE.CREDIT_CARD:
                return <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.payment_type.credit-card"
                        defaultMessage="Credit Card"
                    />
                </span>
            case PAYMENT_TYPE.BANK_TRANSFER:
                return <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.payment_type.bank-transfer"
                        defaultMessage="Bank Transfer"
                    />
                </span>
            case PAYMENT_TYPE.CREDIT:
                return <span className="payment-method-label">
                    <FormattedMessage
                        id="invoice.payment_refund_table.payment_type.credit"
                        defaultMessage="Credit"
                    />
                </span>
            default:
                return <span className="payment-method-label">{props.paymentType}</span>
            }
        }
    }

    return (
        <>
            {getCreditCardPaymentLabel()}
            {getBankAccountPaymentLabel()}
            {getOtherPaymentLabel()}
        </>
    )
}

export default injectIntl(PaymentTypeLabel)


// WEBPACK FOOTER //
// ./src/invoice/components/PaymentTypeLabel/PaymentTypeLabel.tsx